import { render, staticRenderFns } from "./Bimini_defaultSection.vue?vue&type=template&id=f6113c9a&scoped=true"
import script from "./Bimini_defaultSection.vue?vue&type=script&lang=ts"
export * from "./Bimini_defaultSection.vue?vue&type=script&lang=ts"
import style0 from "./Bimini_defaultSection.vue?vue&type=style&index=0&id=f6113c9a&prod&lang=css"
import style1 from "./Bimini_defaultSection.vue?vue&type=style&index=1&id=f6113c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6113c9a",
  null
  
)

export default component.exports